// MyInfo
import React from "react";
import MemberUpdate from "../../components/member/sign-up/MemberUpdate";

const MyInfo = () => {
  console.log("MyInfo component loaded");
  return <MemberUpdate />;
};

export default MyInfo;
